import axios from 'axios'
import constants from '../lib/constants'

export const GET_APPOINTMENTS = 'GET_APPOINTMENTS'
export const GET_APPOINTMENTS_COMPLETE = 'GET_APPOINTMENTS_COMPLETE'
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT'
export const UPDATE_APPOINTMENT_COMPLETE = 'UPDATE_APPOINTMENT_COMPLETE'
export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT'
export const CREATE_APPOINTMENT_COMPLETE = 'CREATE_APPOINTMENT_COMPLETE'

export const getAppointments = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_APPOINTMENTS })
    return axios.get(`${constants.API_URL}/appointments/`)
    .then((response) => {
      dispatch({
        type    : GET_APPOINTMENTS_COMPLETE,
        payload : {
          appointments: response.data.appointments,
        }
      })
      return response
    })
  }
}

export const createAppointment = (
  patientId,
  startTime,
  endTime,
  recurrence,
  userId
  ) => {
  return (dispatch, getState) => {
    dispatch({ type: CREATE_APPOINTMENT })
    return axios.post(`${constants.API_URL}/appointments/create`, {
      patient_id: patientId,
      start_time: startTime,
      end_time: endTime,
      recurrence: recurrence,
      user_id: userId
    })
    .then((response) => {
      dispatch({
        type: CREATE_APPOINTMENT_COMPLETE,
        payload: response.data
      })
      return response
    })
  }
}

export const getNearbyAppointmentsOLD = (patientId) => {
  return (dispatch, getState) => {
    return axios.get(`${constants.API_URL}/tooling/concierge/patients/close_to/${patientId}`)
    .then((response) => {
      return response
    })
  }
}

export const getNearbyAppointments = (patientId) => {
  return (dispatch, getState) => {
    return axios.get(`${constants.API_URL}/tooling/concierge/appointments/nearby/${patientId}`)
    .then((response) => {
      return response.data
    })
  }
}

const ACTION_HANDLERS = {
  [GET_APPOINTMENTS_COMPLETE] : (state, action) => {
    const { appointments } = action.payload
    const newState = {
      ...state,
      ...appointments
    }
    return newState
  },

  [CREATE_APPOINTMENT_COMPLETE]: (state, action) => {
    const appointment = action.payload
    return {
      ...state,
      appointment: appointment
    }
  }
}

// REDUCER

const initialState = {
}

export default function appointmentsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/appointments.js